import React, { useEffect, useState } from "react";
import { Breadcrumb as BreadcrumbReact } from "react-bootstrap";
import "./SearchBar.scss";
import { useTranslation } from "react-i18next";
import SearchResults from "../SearchResults/SearchResults";
import {
  ERROR_MSG,
  LABELKEYS_SEARCH_BAR,
  SEARCH_RESULTS_ATTRIBUTES,
  RECORDS_PER_PAGE_SEARCH_RESULTS,
  PATHNAMEURL,
  BROWSE_PUBLICATIONS,
  LABELKEYS_SEARCH_RESULTS,
  APP_TITLES,
} from "../../../helper/constants";
import Feature from "../../common/FeatureFlags/Feature/Feature";
import { FeatureFlags } from "../../common/FeatureFlags/FeatureFlags";
import { useLocation } from "react-router-dom";
import MyTopFiveFavorite from "../MyTopFiveFavorite/MyTopFiveFavorite";
import ErrorModal from "../../common/ErrorModal/ErrorModal";
import { FacetFilterActions } from "../../../storage/reducers/facetFilterReducer";
import { DeepFacetFilterActions } from "../../../storage/reducers/deepFilterFacets";
import { useDispatch, useSelector } from "react-redux";
import { listItemTextClasses } from "@mui/material";
import RecentlyDownload from "../RecentlyDownload/RecentlyDownload";
import { useNavigate } from "react-router-dom";
import { ScrollPageActions } from "../../../storage/reducers/scrollPageReducer";
import { Button } from "react-bootstrap";
import "../SearchResults/SearchResults.scss";
import { utilAnalytics } from "../../common/analytics/analyticsUtil";
import cssSlice, { cssReducer } from "../../../storage/reducers/cssGlobalReducer";
import Hangar from "../Hangar/Hangar";
import { setMenuSelection } from "../../../storage/reducers/menuSelectorReducer";
import { toggleManualsSlice } from "../../../storage/reducers/toggleManualsReducer";
import { Button_V2 } from "../../common/Button_V2";
const SearchBar = (props) => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [searchvalue, setSearchValue] = useState<any>("");
  const [msg, setMessage] = useState("");
  const [searchdata, setSearchData] = useState([]);
  const [loder, setLoad] = useState(false);
  const { pathname } = useLocation();
  const location = useLocation();
  const [showBrowseBy, setShowBrowseBy] = useState(true);
  const [inputvalue, setInputValue] = useState<any>("");
  const [errMSG, setErorState] = useState({ falg: false, msg: "" });
  const [isStartOver, setIsStartOver] = useState(false);
  const [urldata, setUrlData] = useState(location.state);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPageSelected, setisPageSelected] = useState(false);
  const [payload, setPayload] = useState<any>([]);
  const [pageSelectedCheck, setPageSelectedCheck] = useState(false);
  const recordsPerPage = RECORDS_PER_PAGE_SEARCH_RESULTS;
  const selectedFactesStateVal = useSelector((state: any) => {
    return state.filteredFacets.selectedFactes;
  });
  const facetObjStateVal = useSelector((state: any) => {
    return state.filteredFacets.facetObj;
  });
  const deepFacetLevels = useSelector((state: any) => {
    return state.deepFacetLevels.deepLevel;
  });
  const scrollPositionPageNo = useSelector((state: any) => {
    return state?.scrollPagePositionLevel?.pageNo;
  });
  // toggle dispatch
  const toggleState = useSelector((state: any) => state.toggleManuals);
  useEffect(() => {
    if (selectedFactesStateVal?.queryString === undefined) {
      setSearchData([]);
      setSearchValue("");
      setInputValue("");
      setShowBrowseBy(true);
    }
    dispatch(setMenuSelection({ currentMenuTitle: APP_TITLES.HOME }));
  }, [selectedFactesStateVal]);
  const getSerachRecord = (e) => {
    setLoad(true);
    setIsStartOver(false);
    setCurrentPage(1);
    setSearchValue(inputvalue);
    resetFilterFacetObject();
    // Always reset to normal mode when user performs a search
    if (toggleState.isToggled) {
      dispatch(toggleManualsSlice.actions.toggleManualsOff());
    }
    getSearchResults(inputvalue, true, 1);
    dispatch(cssReducer(false));
  };
  const handleBrowseBy = () => {
    setCurrentPage(1);
    setShowBrowseBy(false);
    setInputValue("");
    resetFilterFacetObject();
    setSearchValue("*");
    // Always switch to normal mode for browse functionality
    if (toggleState.isToggled) {
      dispatch(toggleManualsSlice.actions.toggleManualsOff());
    }
    getSearchResults("*", true, 1);
    dispatch(cssReducer(false));
  };
  const resetFilterFacetObject = () => {
    dispatch(
      FacetFilterActions.getSelectedFilterData({
        facetObjectVal: "",
        facetPayloadVal: {
          queryString: inputvalue && inputvalue || searchvalue,
          pageable: {
            pageNo: 1,
            pageSize: recordsPerPage.toString(),
            sortBy: "",
            sortDir: ""
          }
        },
      })
    );
  };
  const { t } = useTranslation();
  const handleChange = (event) => {
    setInputValue(event.target.value);
    if (event.target.value === "") {
      setMessage("");
    }
    if (event.key === "Enter") {
      dispatch(FacetFilterActions.getSelectedFilterData({ emptySearch: true }));
      setLoad(true);
      setSearchValue(event.target.value);
      setCurrentPage(1);
      dispatch(cssReducer(false));
      dispatch(
        ScrollPageActions.getScrollPagePosition({
          pageNo: 1,
        })
      );
      setPageSelectedCheck(true);
      setIsStartOver(false);
      if (toggleState.isToggled) {
        dispatch(toggleManualsSlice.actions.toggleManualsOff());
      }
      resetFilterFacetObject();
      getSearchResults(event.target.value, true, 1);
    }
  };
  const Loader = () => {
    return <div className="loader"></div>;
  };
  const initFeatures = () => {
    if (!sessionStorage.getItem("flags")) {
      sessionStorage.setItem("flags", JSON.stringify(FeatureFlags));
    }
  };
  const getPageableObj = (page) => {
    const pageObj = {
      pageNo: page.toString(),
      pageSize: recordsPerPage.toString(),
      sortBy: "",
      sortDir: "",
    };
    return pageObj;
  };
  const getPayload = (value, pageNo, flag) => {
    const pageableObj = getPageableObj(pageNo);
    let payload: any = {};
    if (!flag) {
      payload = { ...selectedFactesStateVal };
    }
    payload["queryString"] = value === "" ? "" : value.trim();
    payload["pageable"] = pageableObj;
    return payload;
  };
  // Add this helper function to determine if we should be in manual mode
  const shouldUseManualMode = (searchValue: string) => {
    // Only use manual mode for actual search terms, not for "*" (browse)
    return toggleState.isToggled && searchValue.trim() !== "*" && searchValue.trim() !== "";
  };
  const getSearchResults = async (searchvalue, flag, pageNumber) => {
    setLoad(true);
    try {
      if (searchvalue === "") {
        searchvalue += " ";
      }
      if (!isStartOver) {
        dispatch(
          FacetFilterActions.getSelectedFilterData({
            facetObjectVal:
              flag === true
                ? undefined
                : facetObjStateVal
                  ? facetObjStateVal
                  : undefined,
            facetPayloadVal: getPayload(searchvalue, pageNumber, flag),
          })
        );
        dispatch(
          DeepFacetFilterActions.getDeepLevelFacets({
            deepLevel: deepFacetLevels,
          })
        );
      }
      const payload = getPayload(searchvalue, pageNumber, flag);
      const response = await fetch("/api/v1/search/search-results", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.message?.isSuccess === true) {
        dispatch(setMenuSelection({ currentMenuSelection: "" }));
        setLoad(false);
        setSearchData(data?.message?.result);
        setMessage("");
        if (data?.message?.result?.hits?.total?.value > 0) {
          if (searchvalue.trim() === "") {
            setShowBrowseBy(true);
          } else {
            setShowBrowseBy(false);
          }
          utilAnalytics(
            true,
            {
              eVar2: inputvalue ? inputvalue : "*",
              eVar90: data?.message?.result?.hits?.total?.value,
              events: "event1",
              linkName: "Successful Technical Publications Search",
            },

            pathname

          );

        } else {

          setShowBrowseBy(true);

          utilAnalytics(

            true,

            {

              eVar90: 0,

              eVar2: inputvalue ? inputvalue : "",

              events: "event1, event2",

              linkName: "Unsuccessful Technical Publications Search",

            },

            pathname

          );

        }

      } else if (

        data?.message?.isSuccess === false &&

        data?.message?.statusCode === 400

      ) {

        setErorState({ falg: true, msg: t(ERROR_MSG.INVALID_SEARCH_KEYWORD) });

        setShowBrowseBy(true);

        dispatch(setMenuSelection({ currentMenuSelection: "" }));

      } else {

        setLoad(false);

        setMessage(data?.message?.result);

        setErorState({ falg: true, msg: data?.message?.result });

      }

    } catch (error) {

      setErorState({ falg: true, msg: t(ERROR_MSG.ERROR_MS) });

      setLoad(false);

    }

  };

  // Same clear logic previously bound to the standalone "Clear Search" /

  // "Start Over" button — now wired to the inline "X" icon inside the search box.

  const onClickStartOverBtn = () => {

    setIsStartOver(true);

    setSearchValue("*");

    resetFilterFacetObject();

    setInputValue("");

    dispatch(

      ScrollPageActions.getScrollPagePosition({

        pageNo: 1,

      })

    );

    setPageSelectedCheck(true);

    getSearchResults("*", true, 1);

    setCurrentPage(1);

    // If in manual mode, switch back to normal

    // Always switch back to normal mode on start over

    if (toggleState.isToggled) {

      dispatch(toggleManualsSlice.actions.toggleManualsOff());

    }

  };

  useEffect(() => {

    const pubNoVal = window.location.search.split("=")[1];

    // Only handle URL parameter searches

    if (

      pubNoVal &&

      window.location.search.split("=")[0].split("?")[1] === "pubno" &&

      !isStartOver

    ) {

      const pubNumberValue = decodeURIComponent(decodeURIComponent(pubNoVal));

      setSearchValue(pubNumberValue);

      setInputValue(pubNumberValue);

      getSearchResults(pubNumberValue, false, 1);

    } else {

      // Only set UI state, don't trigger searches automatically

      if (selectedFactesStateVal?.queryString &&

        selectedFactesStateVal?.queryString.trim() !== "" &&

        !isStartOver) {

        if (toggleState.isToggled) {

          setInputValue("*");

          setSearchValue("*");

        } else {

          setInputValue(selectedFactesStateVal?.queryString);

          setSearchValue(selectedFactesStateVal?.queryString);

        }

      }

    }

    initFeatures();

  }, [urldata, isStartOver, toggleState.isToggled]);

  const [data, setData] = useState("");

  const searchResultToSearchBar = (id, flag) => {

    const updatedSearchData: any = searchdata;

    updatedSearchData?.hits?.hits.forEach((element) => {

      if (element._id == id) {

        element._source.is_favourite_flag = flag;

      }

    });

    setData(updatedSearchData);

  };

  const onChange = () => {

    setErorState({ falg: false, msg: "sucsess" });

  };

  useEffect(() => {

    if (pathname === PATHNAMEURL &&

      scrollPositionPageNo &&

      selectedFactesStateVal?.queryString &&

      selectedFactesStateVal?.queryString.trim() !== "") {

      onPageSelected(scrollPositionPageNo);

    }

  }, [scrollPositionPageNo, currentPage]);

  const onPageSelected = (page) => {

    if (!selectedFactesStateVal?.queryString ||

      selectedFactesStateVal?.queryString.trim() === "") {

      return;

    }

    const pageIsSelected = true;

    setisPageSelected(pageIsSelected);

    if (pageSelectedCheck) {

      setCurrentPage(1);

    } else {

      setCurrentPage(page);

    }

    if (

      selectedFactesStateVal?.selectedFacets?.length !== 0 ||

      selectedFactesStateVal?.range !== undefined ||

      selectedFactesStateVal?.fromDate !== undefined

    ) {

      getSearchResults(selectedFactesStateVal?.queryString, false, page);

    } else {

      getSearchResults(selectedFactesStateVal?.queryString, true, page);

    }

    setPageSelectedCheck(false);

  };

  const OnSelectTopFiveFav = (data) => {

    setInputValue(data);

    setSearchValue(data);

    setIsStartOver(false);

    getSearchResults(data, true, 1);

    dispatch(

      FacetFilterActions.getSelectedFilterData({

        facetObjectVal: "",

        facetPayloadVal: {

          queryString: data,

          pageable: {

            pageNo: 1,

            pageSize: recordsPerPage.toString(),

            sortBy: "",

            sortDir: "",

          },

        },

      })

    );

  };

  return (
    <>
      <div className="search-bar customsearchbar">
        <div className="search-bar">
          <div className="searchbar aeroTechPubSearch aem-GridColumn aem-GridColumn--default--12 block-element">
            <input

              type="hidden"

              id="tech-searchbar-errormessage"

              aria-label="display error message"

            />
            <input

              type="hidden"

              value="10"

              id="searchResultsPerPage"

              aria-label="display search results"

            />
            <div className="tech-searchbar">
              <div className="searchbarwrap full-width darkgrey-bg">
                <div

                  className={

                    showBrowseBy ? "blockclass" : "blockclass-startover"

                  }
                >
                  <div className="searchbarcontainer">
                    <div className="find-pub">
                      <h2>{t(LABELKEYS_SEARCH_BAR.SUBHEAD)}</h2>
                    </div>
                    <div className="row">
                      <div className="search__field--aero d-flex input-group custominputgroup">
                        <label htmlFor="search_query">
                          <input

                            title={t(LABELKEYS_SEARCH_BAR.TITLE)}

                            name="search_query"

                            className="form-control searchinput searchbox"

                            id="search_query"

                            aria-label="Search Query"

                            placeholder="Search by Part Number, Pub Number, ATA Code or Keyword"

                            aria-placeholder="Search by Part Number, Pub Number, ATA Code or Keyword"

                            type="text"

                            onChange={handleChange}

                            onKeyDown={handleChange}

                            value={inputvalue}

                          />
                        </label>

                        {/* Inline "X" clear icon — replaces the old standalone

                            Clear Search / Start Over button. Only shown once

                            there's something to clear, and reuses the exact

                            same onClickStartOverBtn logic. */}

                        {inputvalue && (
                          <div className="clear-icon-div">
                            <Button_V2

                              type="tertiary"

                              mode="default"

                              size="small"

                              onClick={onClickStartOverBtn}

                              variant="IconButton"

                              className="clearsearchicon"

                              aria-label="Clear search"
                            >
                              <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.5 2.5L2.5 9.5M2.5 2.5L9.5 9.5" stroke="#1E1E25" strokeWidth="1.5" strokeLinecap="round" />
                              </svg>
                            </Button_V2>
                          </div>

                        )}

                        <div className="search-icon-div">
                          <Button_V2

                            type="primary"

                            mode="default"

                            size="small"

                            onClick={() =>

                              getSerachRecord(inputvalue)

                            }

                            variant="IconButton"

                            className="searchiconfigma"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 7.33337C12 4.75605 9.91064 2.66671 7.33331 2.66671C4.75598 2.66671 2.66665 4.75605 2.66665 7.33337C2.66665 9.9107 4.75598 12 7.33331 12C8.59332 12 9.73587 11.4998 10.5755 10.6882C10.5918 10.6675 10.6098 10.648 10.6289 10.6289C10.6479 10.6099 10.6675 10.5918 10.6881 10.5756C11.4997 9.73593 12 8.59339 12 7.33337ZM13.3333 7.33337C13.3333 8.75002 12.8412 10.0511 12.0202 11.0775L14.4713 13.5287C14.7317 13.789 14.7317 14.211 14.4713 14.4714C14.211 14.7317 13.789 14.7317 13.5286 14.4714L11.0775 12.0202C10.051 12.8413 8.74996 13.3334 7.33331 13.3334C4.0196 13.3334 1.33331 10.6471 1.33331 7.33337C1.33331 4.01967 4.0196 1.33337 7.33331 1.33337C10.647 1.33337 13.3333 4.01967 13.3333 7.33337Z" fill="currentColor"/>
                            </svg>
                          </Button_V2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {showBrowseBy && (
                  <>
                    <div className="or_block">

                      {t(LABELKEYS_SEARCH_RESULTS.OR)}
                    </div>
                    <div className="blockcl">
                      <div className="d-grid gap-2">
                        <Button_V2

                          type="primary"

                          mode="default"

                          size="large"

                          onClick={handleBrowseBy}

                          className="submitbrowbybutton"

                        >

                          {BROWSE_PUBLICATIONS}
                        </Button_V2>
                      </div>
                    </div>
                  </>

                )}
              </div>
            </div>

            {loder && <Loader />}

            {msg != "" && loder === false ? (
              <div className="InvalidRequest">
                <h1 className="error-msg">{msg}</h1>
              </div>

            ) : (
              <Feature name="Search Results">
                <SearchResults

                  dataSearch={searchdata && searchdata}

                  searchval={searchvalue && searchvalue}

                  facetFilter={true}

                  load={loder}

                  showMore={true}

                  attributes={SEARCH_RESULTS_ATTRIBUTES}

                  searchResultToSearchBar={searchResultToSearchBar}

                  setIsStartOver={setIsStartOver}

                  isStartOver={isStartOver}

                  onPageSelected={onPageSelected}

                  currentPage={currentPage}

                  paginator={true}

                  showBrowseBy={showBrowseBy}

                  setShowBrowseBy={setShowBrowseBy}

                />
              </Feature>

            )}

            <div className="searchtipcontainer container">
              <div

                className="float-right searchbar-searchtip"

                id="searchtip-right"
              >
                <a

                  href="/us/en/navigation/services-and-support/support-center"

                  target="_blank"

                  title="search"
                >

                  .
                </a>
              </div>
            </div>
            <div className="searchtipcontainer container">
              <div className="search-tip"></div>
            </div>
          </div>
        </div>
      </div>

      {(searchdata.length === 0 && !loder) && (
        <>
          <Hangar />
          <MyTopFiveFavorite OnSelectTopFiveFav={OnSelectTopFiveFav} />
          <RecentlyDownload></RecentlyDownload>
        </>

      )}

      {(searchdata === undefined ||

        (errMSG?.falg &&

          errMSG?.msg === t(ERROR_MSG.INVALID_SEARCH_KEYWORD))) && (
          <ErrorModal

            errorMsg={errMSG.msg}

            errorFlag={errMSG.falg}

            onClose={onChange}

          />

        )}
    </>

  );

};

export default SearchBar;